import { endOfToday, parse, parseISO, startOfYesterday } from "date-fns";
import { first, last, orderBy } from "lodash";
import { useMemo } from "react";
import { doesAnyDatePointMatchDate } from "../../../utils/DataArrays/doesAnyDatePointMatchDate";
import fillInterpolatedData from "../../../utils/DataArrays/fillInterpolatedData";
import { dateFormat } from "../../PerformanceGroups/Shared";
import { getStartDateFromTimeFrame } from "../../PerformanceGroups/utilities/timeframes";
import useManuallyTrackedAccountDetail from "./useManuallyTrackedAccountDetail";
export default function useManuallyTrackedAccountGraph(manualAssetId, timeFrame, customTimeFrame, auth) {
    const manualAsset = useManuallyTrackedAccountDetail(manualAssetId, auth);
    return useMemo(() => {
        if (manualAsset.data === undefined) {
            return manualAsset;
        }
        if (manualAssetId === null) {
            return { data: undefined, isLoading: true, hasError: false };
        }
        const dataToFill = manualAsset.data.values.map((v) => ({
            date: parseISO(v.createdAt),
            value: v.value,
        }));
        const sortedDataToFill = orderBy(dataToFill, [(p) => p.date.valueOf()], ["asc"]);
        const now = new Date();
        // add data point for today if not present
        const dataWithTodaysDate = doesAnyDatePointMatchDate(now)(sortedDataToFill)
            ? sortedDataToFill
            : [
                ...sortedDataToFill,
                { date: now, value: last(sortedDataToFill)?.value ?? 0 },
            ];
        // get `startDate` relative to selected timeFrame
        const startDate = getStartDateFromTimeFrame(timeFrame, customTimeFrame, now) ??
            first(dataWithTodaysDate)?.date ??
            startOfYesterday();
        // `endDate` is always current day except when timeFrame === "Custom", if customTimeFrame?.endDate === undefined then `endDate` is also always current day as a fallback
        let endDate = last(dataWithTodaysDate)?.date ?? endOfToday();
        if (timeFrame === "Custom") {
            if (customTimeFrame === null) {
                throw new Error("timeFrame === Custom but customTimeFrame is null [useManuallyTrackedAccountGraph]");
            }
            endDate = parse(customTimeFrame.endDate, dateFormat, new Date());
        }
        const filledData = fillInterpolatedData(startDate, endDate, dataWithTodaysDate);
        return {
            data: filledData,
            isLoading: false,
            hasError: false,
        };
    }, [manualAsset, manualAssetId, timeFrame, customTimeFrame]);
}
//# sourceMappingURL=useManuallyTrackedAccountGraph.js.map